import IDNameValidation from 'ui/sections/notarize/pages/IDNameValidation';
import { NotarizationStatus } from 'utils/enums';

export default class IDNameSpouseValidation extends IDNameValidation {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.ID_NAME_SPOUSE_VALIDATION;
}
